import { useCurrentUser } from 'hooks/auth';

import { RegionEnum, Talent } from '@libs/graphql-types';

export const useCurrentTalentRegion = () => {
  const { getData } = useCurrentUser();
  const region = getData()?.data?.currentTalent?.region;

  return region;
};

export const isUsTalent = (talent?: Talent) => {
  return talent?.region === RegionEnum.Us;
};

export const isAuTalent = (talent?: Talent) => {
  return talent?.region === RegionEnum.Australia;
};

export const useIsUsCurrentTalent = () => {
  const { data } = useCurrentUser();
  return isUsTalent(data?.currentTalent);
};

export const useIsAuCurrentTalent = () => {
  const { data } = useCurrentUser();
  return isAuTalent(data?.currentTalent);
};

export const useShowWorkAuthorization = () => {
  const { data } = useCurrentUser();
  const talent = data?.currentTalent;
  return isUsTalent(talent) || isAuTalent(talent);
};
